import {Injectable} from '@angular/core';
import {
  HttpErrorResponse, HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse,
  HttpSentEvent, HttpUserEvent
} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {catchError} from 'rxjs';
import {AuthorizationService} from '../modules/shared/service/authorization.service';
import {ActivatedRoute, ActivatedRouteSnapshot, Router} from '@angular/router';
import {LoggerService} from '../modules/shared/service/logger.service';
import {environment} from '../../environments/environment';
import {EnvironmentType} from '../modules/shared/enums/enums';
import {TokenService} from '../modules/shared/service/token.service';
import { ApiRoutes } from '../config/api-routes';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private logger: LoggerService, private router: Router, private tokenService: TokenService,
              private authorizationService: AuthorizationService, private routes: ApiRoutes,
              private activatedRoute: ActivatedRoute) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    if (this.authorizationService.isUserLoggedIn()) {
      this.authorizationService.refreshTokensIfNeeded();
      req = this.ifOnLocalCloneRequestWithTokensInHeaders(req);
      return next.handle(req).pipe(
        catchError((error, caught) => {
          if (error instanceof HttpErrorResponse) {
            switch ((<HttpErrorResponse>error).status) {
              case 401:
                this.router.navigateByUrl(this.router.createUrlTree(['login'], {queryParams: this.activatedRoute.snapshot.queryParams}));
                return of(null);
              default:
                return throwError(error);
            }
          } else {
            return next.handle(req);
          }
        })
      );
    } else if (this.tokenService.doesTokenExistLocally()) {
      this.authorizationService.signout();
      return next.handle(req);
    } else {
      return next.handle(req);
    }
  }

  private ifOnLocalCloneRequestWithTokensInHeaders(req: HttpRequest<any>): HttpRequest<any> {
    if (environment.environmentName === EnvironmentType.LOCAL) {
      return req.clone({
        setHeaders: {
          'jwt': this.tokenService.getToken(),
          'refreshtoken': this.tokenService.getRefreshToken(),
        }
      });
    } else {
      return req;
    }
  }
}
